import * as React from "react"
import { useTokenRefreshMutation } from "@digits-graphql/admin/graphql-public"
import useSession from "@digits-shared/hooks/useSession"
import useSessionTokenRefresh from "src/shared/components/Session/useSessionTokenRefresh"

export const AdminBearerRefresh: React.FC = () => {
  const session = useSession()
  const [tokenRefreshMutation] = useTokenRefreshMutation()
  useSessionTokenRefresh(tokenRefreshMutation)

  // Proactively validate the session on mount by triggering a token refresh.
  // This detects stale sessions immediately
  // rather than waiting for the first user-initiated query.
  React.useEffect(() => {
    if (session.hasUserData) {
      session.nonBlockBearerRefresh()
    }
  }, [session])

  return null
}
